/*
 * @Author: Ryan
 * @Date: 2026-02-04
 * @Description: Start button component for Face Swap SEO page
 */
import Link from 'next/link';
import React from 'react';

import { scrollToTop } from '@/utils/landing/scrollToTop';

import styles from './StartButton.module.scss';

export interface StartButtonProps {
  text?: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  style?: React.CSSProperties;
}

const StartButton: React.FC<StartButtonProps> = ({
  text = 'Try Face Swap Free',
  href,
  onClick,
  className,
  style,
}) => {
  const buttonClassName = `${styles.button} ${className || ''}`.trim();

  if (href) {
    return (
      <Link href={href} className={buttonClassName} style={style}>
        {text}
      </Link>
    );
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      scrollToTop();
    }
  };

  return (
    <button type="button" onClick={handleClick} className={buttonClassName} style={style}>
      {text}
    </button>
  );
};

export default StartButton;
